import { compose, path, split, partialRight } from 'ramda';
var splitByDot = split('.');

var searchableComponent = boundedCallback => compose(partialRight(path, [boundedCallback()]), splitByDot);

export { searchableComponent };
//# sourceMappingURL=searchableComponent.js.map